export enum AddressSearchAction {
    ADDRESS = 'Address',
    ADDRESSALL = 'AddressAll',
    ADDRESSKEYWORD = 'AddressKeyword',
}
